/* eslint-disable */

export const getRequest =  `
  query GetRequest($id: ID!) {
    getRequest(id: $id) {
      id
      requestDate
      startTime
      duration
      description
      isConfirmed
      isPending
      userID
      companyID
      address
      putOff
      groupId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRequests =  `
  query ListRequests(
    $filter: ModelRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        requestDate
        startTime
        duration
        description
        isConfirmed
        isPending
        userID
        companyID
        address
        putOff
        groupId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const requestsByUserID =  `
  query RequestsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requestsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        requestDate
        startTime
        duration
        description
        isConfirmed
        isPending
        userID
        companyID
        address
        putOff
        groupId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const requestsByCompanyID =  `
  query RequestsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requestsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        requestDate
        startTime
        duration
        description
        isConfirmed
        isPending
        userID
        companyID
        address
        putOff
        groupId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReport =  `
  query GetReport($id: ID!) {
    getReport(id: $id) {
      id
      conversationID
      userID
      reportedUserID
      reasonGiven
      reasonWhy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listReports =  `
  query ListReports(
    $filter: ModelReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conversationID
        userID
        reportedUserID
        reasonGiven
        reasonWhy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPaymentMethod =  `
  query GetPaymentMethod($id: ID!) {
    getPaymentMethod(id: $id) {
      id
      stripeCardToken
      nameOnCard
      brand
      userID
      last4
      expMonth
      expYear
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPaymentMethods =  `
  query ListPaymentMethods(
    $filter: ModelPaymentMethodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentMethods(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        stripeCardToken
        nameOnCard
        brand
        userID
        last4
        expMonth
        expYear
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const paymentMethodsByUserID =  `
  query PaymentMethodsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentMethodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    paymentMethodsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        stripeCardToken
        nameOnCard
        brand
        userID
        last4
        expMonth
        expYear
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSchedule =  `
  query GetSchedule($id: ID!) {
    getSchedule(id: $id) {
      id
      day
      allDay
      from
      to
      companyID
      userID
      address
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSchedules =  `
  query ListSchedules(
    $filter: ModelScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSchedules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        day
        allDay
        from
        to
        companyID
        userID
        address
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const schedulesByCompanyID =  `
  query SchedulesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    schedulesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        day
        allDay
        from
        to
        companyID
        userID
        address
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSavedReview =  `
  query GetSavedReview($id: ID!) {
    getSavedReview(id: $id) {
      id
      reviewID
      savedID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSavedReviews =  `
  query ListSavedReviews(
    $filter: ModelSavedReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSavedReviews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reviewID
        savedID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const savedReviewsByReviewID =  `
  query SavedReviewsByReviewID(
    $reviewID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSavedReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    savedReviewsByReviewID(
      reviewID: $reviewID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reviewID
        savedID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessages =  `
  query GetMessages($id: ID!) {
    getMessages(id: $id) {
      id
      conversationID
      senderID
      receiverID
      messageContent
      readStatus
      timeStamp
      lastSent
      receiverDeleted
      senderDeleted
      attachmentkey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMessages =  `
  query ListMessages(
    $filter: ModelMessagesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conversationID
        senderID
        receiverID
        messageContent
        readStatus
        timeStamp
        lastSent
        receiverDeleted
        senderDeleted
        attachmentkey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByConversationID =  `
  query MessagesByConversationID(
    $conversationID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMessagesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByConversationID(
      conversationID: $conversationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        receiverID
        messageContent
        readStatus
        timeStamp
        lastSent
        receiverDeleted
        senderDeleted
        attachmentkey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByReceiverID =  `
  query MessagesByReceiverID(
    $receiverID: String!
    $timeStamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessagesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByReceiverID(
      receiverID: $receiverID
      timeStamp: $timeStamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        receiverID
        messageContent
        readStatus
        timeStamp
        lastSent
        receiverDeleted
        senderDeleted
        attachmentkey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesBySenderID =  `
  query MessagesBySenderID(
    $senderID: String!
    $timeStamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessagesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesBySenderID(
      senderID: $senderID
      timeStamp: $timeStamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        receiverID
        messageContent
        readStatus
        timeStamp
        lastSent
        receiverDeleted
        senderDeleted
        attachmentkey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBankMethod =  `
  query GetBankMethod($id: ID!) {
    getBankMethod(id: $id) {
      id
      stripeBankToken
      last4
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBankMethods =  `
  query ListBankMethods(
    $filter: ModelBankMethodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBankMethods(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        stripeBankToken
        last4
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bankMethodsByCompanyID =  `
  query BankMethodsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBankMethodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bankMethodsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        stripeBankToken
        last4
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHighlight =  `
  query GetHighlight($id: ID!) {
    getHighlight(id: $id) {
      id
      description
      attachmentkey
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHighlights =  `
  query ListHighlights(
    $filter: ModelHighlightFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHighlights(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        description
        attachmentkey
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const highlightsByCompanyID =  `
  query HighlightsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelHighlightFilterInput
    $limit: Int
    $nextToken: String
  ) {
    highlightsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        attachmentkey
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getContact =  `
  query GetContact($id: ID!) {
    getContact(id: $id) {
      id
      email
      title
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listContacts =  `
  query ListContacts(
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        title
        message
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpecialty =  `
  query GetSpecialty($id: ID!) {
    getSpecialty(id: $id) {
      id
      type
      specialties
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpecialties =  `
  query ListSpecialties(
    $filter: ModelSpecialtyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpecialties(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        specialties
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const specialtiesByCompanyID =  `
  query SpecialtiesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpecialtyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    specialtiesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        specialties
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInvoices =  `
  query GetInvoices($id: ID!) {
    getInvoices(id: $id) {
      id
      totalAmount
      grandAmount
      status
      frequency
      companyID
      userID
      invoiceAttachmentKey
      dueDates
      payments
      feeAmountIncluded
      numberOfPayments
      oneTimePayment
      amount
      latePayments
      resendPayments
      paymentDate
      resent
      readStatus
      hasRefund
      disputed
      dueDateLog
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInvoices =  `
  query ListInvoices(
    $filter: ModelInvoicesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        totalAmount
        grandAmount
        status
        frequency
        companyID
        userID
        invoiceAttachmentKey
        dueDates
        payments
        feeAmountIncluded
        numberOfPayments
        oneTimePayment
        amount
        latePayments
        resendPayments
        paymentDate
        resent
        readStatus
        hasRefund
        disputed
        dueDateLog
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const invoicesByCompanyID =  `
  query InvoicesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelInvoicesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoicesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        totalAmount
        grandAmount
        status
        frequency
        companyID
        userID
        invoiceAttachmentKey
        dueDates
        payments
        feeAmountIncluded
        numberOfPayments
        oneTimePayment
        amount
        latePayments
        resendPayments
        paymentDate
        resent
        readStatus
        hasRefund
        disputed
        dueDateLog
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const invoicesByUserID =  `
  query InvoicesByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelInvoicesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoicesByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        totalAmount
        grandAmount
        status
        frequency
        companyID
        userID
        invoiceAttachmentKey
        dueDates
        payments
        feeAmountIncluded
        numberOfPayments
        oneTimePayment
        amount
        latePayments
        resendPayments
        paymentDate
        resent
        readStatus
        hasRefund
        disputed
        dueDateLog
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReview =  `
  query GetReview($id: ID!) {
    getReview(id: $id) {
      id
      description
      score
      ghost
      attachmentkey
      companyID
      userID
      SavedReviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listReviews =  `
  query ListReviews(
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReviews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        description
        score
        ghost
        attachmentkey
        companyID
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewsByCompanyID =  `
  query ReviewsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        score
        ghost
        attachmentkey
        companyID
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewsByUserID =  `
  query ReviewsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        description
        score
        ghost
        attachmentkey
        companyID
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCompany =  `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      companyUser
      companyName
      companyType
      zipcode
      email
      phone
      companyWebsite
      bio
      Reviews {
        nextToken
        __typename
      }
      Highlights {
        nextToken
        __typename
      }
      profilepicturekey
      backgroundpicturekey
      Invoices {
        nextToken
        __typename
      }
      BankMethod {
        nextToken
        __typename
      }
      town
      state
      Schedules {
        nextToken
        __typename
      }
      Specialties {
        nextToken
        __typename
      }
      emailPrivate
      phonePrivate
      blocked
      lowRange
      highRange
      stripeAccountId
      lowPrivate
      highPrivate
      isDeleted
      deletedAt
      originalUsername
      instantPayout
      Requests {
        nextToken
        __typename
      }
      messageNotifications
      paymentNotifications
      requestNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestNotifications
      isClaimed
      isSeeded
      licenseNumber
      licenseValidTo
      dataSource
      claimedAt
      isBlacklisted
      latitude
      longitude
      borough
      ownerSub
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompanies =  `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyUser
        companyName
        companyType
        zipcode
        email
        phone
        companyWebsite
        bio
        profilepicturekey
        backgroundpicturekey
        town
        state
        emailPrivate
        phonePrivate
        blocked
        lowRange
        highRange
        stripeAccountId
        lowPrivate
        highPrivate
        isDeleted
        deletedAt
        originalUsername
        instantPayout
        messageNotifications
        paymentNotifications
        requestNotifications
        pushMessageNotifications
        pushPaymentNotifications
        pushRequestNotifications
        isClaimed
        isSeeded
        licenseNumber
        licenseValidTo
        dataSource
        claimedAt
        isBlacklisted
        latitude
        longitude
        borough
        ownerSub
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usersByUsername =  `
  query UsersByUsername(
    $user: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByUsername(
      user: $user
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companiesByCompanyUser =  `
  query CompaniesByCompanyUser(
    $companyUser: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByCompanyUser(
      companyUser: $companyUser
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyUser
        companyName
        companyType
        zipcode
        email
        phone
        companyWebsite
        bio
        profilepicturekey
        backgroundpicturekey
        town
        state
        emailPrivate
        phonePrivate
        blocked
        lowRange
        highRange
        stripeAccountId
        lowPrivate
        highPrivate
        isDeleted
        deletedAt
        originalUsername
        instantPayout
        messageNotifications
        paymentNotifications
        requestNotifications
        pushMessageNotifications
        pushPaymentNotifications
        pushRequestNotifications
        isClaimed
        isSeeded
        licenseNumber
        licenseValidTo
        dataSource
        claimedAt
        isBlacklisted
        latitude
        longitude
        borough
        ownerSub
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companiesByOwnerSub =  `
  query CompaniesByOwnerSub(
    $ownerSub: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByOwnerSub(
      ownerSub: $ownerSub
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyUser
        companyName
        companyType
        zipcode
        email
        phone
        companyWebsite
        bio
        profilepicturekey
        backgroundpicturekey
        town
        state
        emailPrivate
        phonePrivate
        blocked
        lowRange
        highRange
        stripeAccountId
        lowPrivate
        highPrivate
        isDeleted
        deletedAt
        originalUsername
        instantPayout
        messageNotifications
        paymentNotifications
        requestNotifications
        pushMessageNotifications
        pushPaymentNotifications
        pushRequestNotifications
        isClaimed
        isSeeded
        licenseNumber
        licenseValidTo
        dataSource
        claimedAt
        isBlacklisted
        latitude
        longitude
        borough
        ownerSub
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser =  `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      user
      name
      email
      phone
      profilepicturekey
      backgroundpicturekey
      Reviews {
        nextToken
        __typename
      }
      Invoices {
        nextToken
        __typename
      }
      PaymentMethod {
        nextToken
        __typename
      }
      blocked
      isDeleted
      deletedAt
      originalUsername
      Requests {
        nextToken
        __typename
      }
      messageNotifications
      paymentNotifications
      requestSatusNotifications
      invoiceNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestSatusNotifications
      pushInvoiceNotifications
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAnalyticsEvents =  `
  query ListAnalyticsEvents(
    $filter: ModelAnalyticsEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalyticsEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventType
        timestamp
        sessionId
        deviceId
        userId
        platform
        page
        referrer
        metadata
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analyticsEventsByEventType =  `
  query AnalyticsEventsByEventType(
    $eventType: String!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalyticsEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analyticsEventsByEventType(
      eventType: $eventType
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventType
        timestamp
        sessionId
        deviceId
        userId
        platform
        page
        referrer
        metadata
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analyticsEventsBySession =  `
  query AnalyticsEventsBySession(
    $sessionId: String!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalyticsEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analyticsEventsBySession(
      sessionId: $sessionId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventType
        timestamp
        sessionId
        deviceId
        userId
        platform
        page
        referrer
        metadata
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analyticsEventsByDevice =  `
  query AnalyticsEventsByDevice(
    $deviceId: String!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalyticsEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analyticsEventsByDevice(
      deviceId: $deviceId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventType
        timestamp
        sessionId
        deviceId
        userId
        platform
        page
        referrer
        metadata
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const analyticsEventsByUserId =  `
  query AnalyticsEventsByUserId(
    $userId: String!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalyticsEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    analyticsEventsByUserId(
      userId: $userId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventType
        timestamp
        sessionId
        deviceId
        userId
        platform
        page
        referrer
        metadata
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUsers =  `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user
        name
        email
        phone
        profilepicturekey
        backgroundpicturekey
        blocked
        isDeleted
        deletedAt
        originalUsername
        messageNotifications
        paymentNotifications
        requestSatusNotifications
        invoiceNotifications
        pushMessageNotifications
        pushPaymentNotifications
        pushRequestSatusNotifications
        pushInvoiceNotifications
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
